import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import classnames from "classnames"
import { setBreadcrumbItems } from "../../store/actions"
import SimpleBar from "simplebar-react/dist"
import user2 from "../../assets/images/users/user-2.jpg"
import {
  Card,
  CardBody,
  Dropdown,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavLink,
  NavItem,
  TabContent,
  TabPane,
  Row,
  UncontrolledDropdown,
  Button,
  Input,
  UncontrolledAlert,
} from "reactstrap"
import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import Spinners from "components/Common/Spinner"
import axios from "axios"

const Chat = props => {
  const [facebookChats, setFacebookChats] = useState(null)
  const dispatch = useDispatch()
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  const [messagesData, setMessagesData] = useState([])
  const [currentRoomId, setCurrentRoomId] = useState(null)
  const [Chat_Box_User_Status, setChat_Box_User_Status] = useState("Available")
  const [Chat_Box_Username, setChat_Box_Username] = useState(null)
  const [Chat_Box_Image, setChat_Box_Image] = useState(user2)
  const [loading, setLoading] = useState(false)
  const [curMessage, setCurMessage] = useState("")
  const [pageDetails, setPageDetails] = useState(null)
  const [isDisable, setDisable] = useState(false)

  const scrollRef = useRef(null)

  useEffect(() => {
    if (scrollRef.current) {
      const scrollElement = scrollRef.current.getScrollElement()
      scrollElement.scrollTop = scrollElement.scrollHeight
    }
  }, [messagesData])

  useEffect(() => {
    fetchPageDetails()
    fetchChats()

    const interval = setInterval(() => {
      fetchChats({ silent: true })
    }, 60000) // Call fetchChats every 60,000 ms (1 minute)

    return () => clearInterval(interval) // Cleanup on unmount
  }, [])

  const fetchPageDetails = async () => {
    try {
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization.InstagramIntegrations[0].pageId}?fields=name,about,attire,bio,location,parking,hours,emails,website,instagram_business_account,picture&access_token=${activeOrganization.InstagramIntegrations[0].pageToken}`,
      )
      setPageDetails(response.data)
    } catch (err) {
      console.log(err)
      props.setErr("Error fetching page details.")
    }
  }

  const fetchChats = async ({ silent = false } = {}) => {
    try {
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization.InstagramIntegrations[0].pageId}/conversations`,
        {
          params: {
            access_token: activeOrganization.InstagramIntegrations[0].pageToken,
            fields:
              "id,from{name,picture},to,message,messages{message,from{name,picture},created_time},updated_time",
          },
          skipLoader: silent,
        },
      )

      const chats = response.data.data
      setFacebookChats(chats)

      if (chats.length > 0) {
        const firstChat = chats[0]
        setMessagesData(firstChat.messages.data)
        setCurrentRoomId(firstChat.id)
        setChat_Box_User_Status("Available")
        setChat_Box_Username(
          firstChat.messages.data.find(
            message => message.from.name !== pageDetails?.name,
          )?.from.name,
        )
      }
    } catch (err) {
      console.log(err)
      props.setErr("Error fetching chats.")
    }
  }

  const userChatOpen = chat => {
    const userName =
      chat.messages.data.find(
        message => message.from.name !== pageDetails?.name,
      )?.from.name || "Unknown User"

    setChat_Box_Username(userName)
    setChat_Box_Image(user2)
    setCurrentRoomId(chat.id)
    setMessagesData(chat.messages.data)
  }

  const sendMessage = async () => {
    if (!curMessage || !currentRoomId) return

    const recipientId = messagesData.find(
      message => message.from.name !== pageDetails?.name,
    )?.from.id

    try {
      const response = await axios.post(
        `https://graph.facebook.com/v20.0/me/messages`,
        {
          recipient: { id: recipientId },
          message: { text: curMessage },
          tag: "POST_PURCHASE_UPDATE",
        },
        {
          headers: {
            Authorization: `Bearer ${activeOrganization.InstagramIntegrations[0].pageToken}`,
          },
        },
      )

      if (response.status === 200) {
        const newMessage = {
          message: curMessage,
          from: {
            name: `${pageDetails?.name}`,
            picture: { data: { url: user2 } },
          },
          created_time: new Date().toISOString(),
        }
        setMessagesData([...messagesData, newMessage])
        setCurMessage("")
        setDisable(false)
      }
    } catch (err) {
      console.log(err)
      props.setErr("Error sending message.")
    }
  }

  return (
    <React.Fragment>
      <div className="d-lg-flex">
        <Card
          className="chat-leftsidebar"
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          <CardBody style={{ maxHeight: "25vh" }}>
            <div className="text-center bg-light rounded px-4 py-3">
              <div className="chat-user-status">
                <img
                  src={pageDetails?.picture.data.url}
                  className="avatar-md rounded-circle"
                  alt=""
                />
              </div>
              <h5 className="font-size-16 mb-1 mt-3">
                <Link to="#" className="text-reset">
                  {pageDetails?.name}{" "}
                </Link>
              </h5>
              <p className="status">{Chat_Box_User_Status}</p>
              <p className="text-muted mb-0">
                {pageDetails?.location.city +
                  ", " +
                  pageDetails?.location.country}
              </p>
            </div>
          </CardBody>

          <div
            className="chat-leftsidebar-nav flex-grow-1 table-responsive"
            style={{ overflow: "auto", height: "40vh" }}
          >
            <TabContent activeTab="1" className="">
              <TabPane tabId="1" className="h-100">
                <SimpleBar className="chat-message-list h-100">
                  <div className="pt-3">
                    <div className="px-3">
                      <h5 className="font-size-14 mb-3">Conversations</h5>
                    </div>
                    <ul className="list-unstyled chat-list p-3">
                      {loading ? (
                        <Spinners setLoading={setLoading} />
                      ) : (
                        <SimpleBar>
                          {facebookChats?.map(chat => {
                            const userName =
                              chat.messages.data.find(
                                message =>
                                  message.from.name !== pageDetails?.name,
                              )?.from.name || "Unknown User"

                            return (
                              <li
                                key={chat.id}
                                className={
                                  currentRoomId === chat.id ? "active" : ""
                                }
                              >
                                <Link to="#" onClick={() => userChatOpen(chat)}>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 user-img align-self-center me-3">
                                      <img
                                        src={chat.image}
                                        className="rounded-circle avatar"
                                        alt=""
                                      />
                                    </div>
                                    <div className="flex-grow-1 overflow-hidden">
                                      <h5 className="text-truncate font-size-15 mb-0">
                                        {userName}
                                      </h5>
                                      <p className="text-muted mb-0 mt-1 text-truncate">
                                        {chat.messages.data[0].message}
                                      </p>
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )
                          })}
                        </SimpleBar>
                      )}
                    </ul>
                  </div>
                </SimpleBar>
              </TabPane>
            </TabContent>
          </div>
        </Card>

        <div className="w-100 user-chat ms-lg-3">
          <Card>
            <div className="p-3 px-lg-4 border-bottom">
              <Row>
                <Col xl={4} className="col-7">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 avatar me-3 d-sm-block d-none">
                      <img
                        src={Chat_Box_Image}
                        alt=""
                        className="img-fluid d-block avatar rounded-circle"
                      />
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-16 mb-1 text-truncate">
                        <Link to="#" className="text-reset">
                          {Chat_Box_Username}
                        </Link>
                      </h5>
                      <p className="text-muted text-truncate mb-0">
                        {Chat_Box_User_Status}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <SimpleBar ref={scrollRef} className="chat-conversation p-4">
              {loading ? (
                <Spinners setLoading={setLoading} />
              ) : (
                <ul className="list-unstyled mb-0">
                  {messagesData &&
                    [...messagesData] // Create a copy of messagesData
                      .sort(
                        (a, b) =>
                          new Date(a.created_time) - new Date(b.created_time),
                      ) // Sort by created_time in ascending order
                      .map((messageDat, index) => (
                        <li
                          key={index}
                          className={
                            messageDat?.from?.name === pageDetails?.name
                              ? "right"
                              : ""
                          }
                        >
                          <div className="conversation-list">
                            <div className="d-flex">
                              {messageDat?.from?.picture?.data?.url && (
                                <img
                                  src={messageDat.from.picture.data.url}
                                  className="rounded-circle avatar"
                                  alt="User"
                                />
                              )}
                              <div className="flex-1 ms-3">
                                <div
                                  className={`d-flex ${
                                    messageDat?.from?.name === pageDetails?.name
                                      ? "justify-content-end"
                                      : "justify-content-start"
                                  }`}
                                >
                                  <h5
                                    className={`font-size-14 conversation-name ${
                                      messageDat?.from?.name ===
                                      pageDetails?.name
                                        ? "align-right"
                                        : "align-left"
                                    }`}
                                  >
                                    {messageDat?.from?.name ===
                                    pageDetails?.name
                                      ? "You"
                                      : messageDat?.from?.name ||
                                        "Unknown User"}
                                  </h5>
                                </div>
                                <div className="ctext-wrap">
                                  <div className="ctext-wrap-content">
                                    <p className="mb-0">
                                      {messageDat?.message || ""}
                                    </p>
                                    <br />
                                    <span className="font-size-12 text-muted align-right">
                                      {new Date(
                                        messageDat?.created_time,
                                      ).toLocaleTimeString("en-US", {
                                        hour: "numeric",
                                        minute: "numeric",
                                        hour12: true,
                                      })}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                </ul>
              )}
            </SimpleBar>

            <div className="p-3 chat-input-section">
              <Row>
                <Col>
                  <div className="position-relative">
                    <Input
                      type="text"
                      value={curMessage}
                      onChange={e => setCurMessage(e.target.value)}
                      placeholder="Enter Message..."
                    />
                  </div>
                </Col>
                <Col className="col-auto">
                  <Button
                    type="button"
                    color="primary"
                    onClick={sendMessage}
                    disabled={!curMessage || isDisable}
                  >
                    <span className="d-none d-sm-inline-block me-2">Send</span>{" "}
                    <i className="mdi mdi-send"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {}
}

export default connect(mapStateToProps, { setBreadcrumbItems })(Chat)
